import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import militaryLoaderHero from '@/assets/landing-activity-male/military-loader-hero-2x.webp'

const schema: LandingScreenSchema = {
	config: {
		background: 'transparent',
	},

	order: [
		'LandingBackgroundImage',
		'LandingHead',
		'LandingTitle',
		'LandingComponentSpacer',
		'LandingProgressLoader',
		'LandingFooter',
	],

	components: {
		LandingBackgroundImage: (): LandingComponentsConfig['LandingBackgroundImage'] => ({
			image: militaryLoaderHero,
		}),

		LandingHead: (): LandingComponentsConfig['LandingHead'] => ({
			logoAlignment: 'center',
			logoColor: 'white',
		}),

		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Military Calisthenics Plan: Train Like a Beast',
			size: 'medium',
			customStyles: {
				color: 'var(--Text-Primary-White, #ffffff)',
				textAlign: 'center',
				marginLeft: '1.5rem',
				marginRight: '1.5rem',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
			label: "Please don't close this page",
			note: 'Analyzing your profile',
			theme: 'white',
		}),
		LandingFooter: (): LandingComponentsConfig['LandingFooter'] => ({
			textColor: 'white',
		}),
	},
}

export default schema
